export default "__VITE_ASSET__DpOZGdeU__"